import { Box, Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useCallback, useMemo, useState } from 'react';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { getEventParticipantById } from 'src/shared/services/eventParticipantService';
import { EventTicketsDataGridFilter } from './eventTicketsDataGridFilter';
import { EventTicketsDataGrid } from './eventTicketsDataGrid';
import { EventTicket } from '../models/eventTicket';
import { EventParticipantTicketSearchFilter } from '../models/eventParticipantTicketSearchFilter';
import { EventParticipant } from '../models/eventParticipant';
import { EventParticipantsDetailModal } from './eventParticipantsDetailModal';

type EventDetailTabTicketsProps = {
  tickets: EventTicket[];
  eventId: number;
  eventName?: string;
  eventDate?: string;
  eventLocation?: string;
};

export const EventDetailTabTickets = (props: EventDetailTabTicketsProps) => {
  const { tickets, eventId, eventName, eventDate, eventLocation } = props;
  const { t } = useTranslation();
  const [searchFilter, setSearchFilter] = useState<EventParticipantTicketSearchFilter>({
    searchString: '',
    selectedTicketTypes: tickets,
  });

  const [showParticipantModal, setShowParticipantModal] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState<EventParticipant | null>(null);

  const memoizedSearchFilter: EventParticipantTicketSearchFilter = useMemo(() => {
    return {
      searchString: searchFilter.searchString,
      selectedTicketTypes: searchFilter.selectedTicketTypes,
    };
  }, [searchFilter.searchString, searchFilter.selectedTicketTypes]);

  const handleOpenParticipant = useCallback(async (participantId: number) => {
    try {
      const res = await getEventParticipantById(participantId);
      setSelectedParticipant(res.data);
      setShowParticipantModal(true);
    } catch (e) {
      ConsoleHelper.log(e);
    }
  }, []);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12}>
          <ContentSection header={t('event:tickets')}>
            <Box sx={{ pt: 1 }}>
              <EventTicketsDataGridFilter tickets={tickets} searchFilter={searchFilter} setSearchFilter={setSearchFilter} />
              <EventTicketsDataGrid
                searchFilter={memoizedSearchFilter}
                eventId={eventId}
                eventName={eventName}
                eventDate={eventDate}
                eventLocation={eventLocation}
                onOpenParticipant={handleOpenParticipant}
              />
            </Box>
          </ContentSection>
        </Grid>
      </GridWrapper>
      {showParticipantModal && selectedParticipant && (
        <EventParticipantsDetailModal
          modalOpen={showParticipantModal}
          participant={selectedParticipant}
          eventId={eventId}
          onClose={() => setShowParticipantModal(false)}
        />
      )}
    </>
  );
};
